import { render, staticRenderFns } from "./TaskDragContainer.vue?vue&type=template&id=1eda2401&"
import script from "./TaskDragContainer.vue?vue&type=script&lang=js&"
export * from "./TaskDragContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports